var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeesvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 297 297",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M284.583,276.914h-30.892c-1.702-19.387-5.386-59.954-7.771-75.858c-2.715-18.113-17.518-33.527-36.835-38.357 l-20.107-5.027c-3.25,19.41-20.159,34.253-40.477,34.253s-37.227-14.843-40.477-34.253l-20.107,5.027 c-19.317,4.829-34.121,20.244-36.835,38.357c-2.385,15.904-6.069,56.471-7.771,75.858H12.417 c-5.546,0-10.043,4.497-10.043,10.043c0,5.546,4.497,10.043,10.043,10.043h272.165c5.546,0,10.043-4.497,10.043-10.043 C294.625,281.411,290.13,276.914,284.583,276.914z M227.18,276.914h-14.06v-65.258H83.881v65.258H69.821v-72.288 c0-3.883,3.147-7.03,7.03-7.03h143.3c3.883,0,7.03,3.147,7.03,7.03V276.914z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.501,114.634c27.103,0,48.125-35.753,48.125-66.509C196.626,18.89,177.735,0,148.501,0s-48.125,18.89-48.125,48.125 C100.376,78.882,121.398,114.634,148.501,114.634z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.774,124.617c-0.053,7.43-1.516,17.95-8.265,25.567c0,14.883,12.107,27.681,26.991,27.681 c14.884,0,26.991-12.798,26.991-27.681c-6.748-7.617-8.212-18.136-8.263-25.567c-5.86,2.617-12.139,4.078-18.727,4.078 C141.914,128.695,135.634,127.234,129.774,124.617z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesvg);
export default __webpack_public_path__ + "static/media/employeesvg.42403b6e7b393881b38fd29d2c43b183.svg";
export { ForwardRef as ReactComponent };